import { customerHooks } from '$src/lib/trpcHooks'
import { isCompanyType } from '@markku/utils'

// Customers the logged-in user belongs to, plus the company / housing-company
// subset that the company portal is built around.
export function useCompanyCustomers() {
  const { data, isLoading } = customerHooks.useList()
  const customers = data?.data || []
  const companies = customers.filter((c) => isCompanyType(c.type))
  return { customers, companies, isLoading }
}
